<template>
  <div>
    <i v-if="loading" class="fa fa-cog fa-spin" style="font-size: 50px"></i>
    <section class="dashboard" v-if="!loading">
      <div class="page-header">
        <h3 class="page-title">Rechnungen ({{ billings.length }}) - {{ sum_billings.toFixed(2) }} Euro</h3>
      </div>

      <div class="row">
        <div class="col-12 grid-margin">
          <div class="card">
            <div class="card-body">
              <!--
                            <b-form-select v-model="stateFilter" :options="account_states" style="margin-bottom:20px;" />
        -->
              <div style="margin-bottom: 10px">
                <label>
                  <input v-model="invoice_open" type="checkbox" data-toggle="toggle" />
                  offene Rechnungen
                </label>
              </div>

              <form class="forms-sample">
                <b-form-group label="" label-for="input1">
                  <b-form-input v-model="invoicefilter" type="text" id="input1"
                    placeholder="Rechnungsnummer"></b-form-input>
                </b-form-group>
              </form>

              <div class="table-responsive">
                <table class="table">
                  <thead>
                    <tr>
                      <th style="cursor: pointer;" @click="sortBy('invoice_nr')">Nr.</th>
                      <th style="cursor: pointer;" @click="sortBy('invoice_date')">Datum</th>
                      <th>Zeitraum</th>
                      <th style="cursor: pointer;" @click="sortBy('emailsend_at')">E-Mail</th>
                      <th style="cursor: pointer;" @click="sortBy('invoice_amount')">Netto</th>
                      <th style="cursor: pointer;" @click="sortBy('invoice_amount')">Brutto</th>
                      <th style="cursor: pointer;" @click="sortBy('paid')">Bezahlt</th>
                      <th></th>
                      <th></th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="item in sortedBillings" :key="item.uid">
                      <td>
                        <a v-if="item.download_file" :href="item.download_file" target="_blank">{{ item.invoice_nr
                          }}</a>
                      </td>
                      <td>{{ item.invoice_date }}</td>
                      <td>
                        {{ item.invoice_range_from }}<br />{{
                          item.invoice_range_to
                        }}
                      </td>
                      <td>
                        <div v-if="item.emailsend_at">
                          <i class="fa fa-envelope-o" aria-hidden="true"></i>
                          {{ item.emailsend_at }}
                        </div>
                      </td>
                      <td>
                        <div class="billing-modal-btn" v-b-modal.modalmd @click="openModal(item)">
                          {{ parseFloat((item.invoice_amount / 100).toFixed(2)) }} Euro
                        </div>
                      </td>
                      <td>
                        <div class="billing-modal-btn" v-b-modal.modalmd @click="openModal(item)">
                          {{ parseFloat((item.invoice_amount / 100 * 1.19).toFixed(2)) }} Euro
                        </div>
                      </td>
                      <td>
                        <i v-if="item.paid" class="fa fa-check" aria-hidden="true"></i>
                        <span v-if="item.paid">{{ item.paid_at }}</span>
                      </td>
                      <td>

                        <div v-for="tag in item.tags" :key="tag" class="badge-container">
                          <span class="badge-tag">{{ tag }}</span>
                        </div>


                      </td>

                      <td style="text-align: right">
                        <router-link target="_blank" class="btn btn-outline-primary btn-fw" :to="{
                          name: 'location-detail',
                          params: { uid: item.location_uid },
                        }">Account</router-link>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>

      <b-modal id="modalmd" title="Details" size="md" ok-only @>
        <form class="forms-sample">
          <!--
          <b-form-group label="Rechnung verschickt" label-for="emailsend">
            <input
              type="checkbox"
              id="emailsend"
              name="emailsend"
              v-model="current_billing.emailsend"
            />
          </b-form-group>
          -->
          <b-form-group label="Rechnung verschickt" label-for="">
            <date-picker v-model="current_billing.emailsend_at" valueType="format" :format="dateFormat"
              placeholder="Datum wählen"></date-picker>
          </b-form-group>

          <!--
          <b-form-group
            label="Bezahlt"
            label-for="paid"
            style="margin-top: 30px"
          >
            <input
              type="checkbox"
              id="paid"
              name="paid"
              v-model="current_billing.paid"
            />
          </b-form-group>
          -->
          <b-form-group label="Bezahlt am" label-for="">
            <date-picker v-model="current_billing.paid_at" valueType="format" :format="dateFormat"
              placeholder="Datum wählen"></date-picker>
          </b-form-group>

          <b-form-group label="Tags" label-for="">
            <b-form-tags input-id="tags-basic" placeholder="" v-model="current_billing.tags"></b-form-tags>
          </b-form-group>

          <b-button variant="success" @click="saveEmailDetails()" class="mr-2">Speichern</b-button>
          <b-alert v-if="modalSaved1" variant="primary" style="margin-top: 20px" show>Gespeichert</b-alert>
        </form>
      </b-modal>
    </section>
  </div>
</template>


<script>
import { updateInvoiceInfo } from "@/services/locations.service";

import { getAllBillings } from "@/services/billings.service";
import DatePicker from "vue2-datepicker";

export default {
  name: "dashboard",
  components: {
    DatePicker,
  },
  data() {
    return {
      time1: null,
      loading: true,
      current_billing: {},
      modalSaved1: false,
      dateFormat: "DD.MM.YYYY",
      invoicefilter: null,
      invoice_open: true,
      sortKey: 'name', // Standard-Sortierschlüssel
      sortOrder: 'asc', // Sortierreihenfolge: 'asc' oder 'desc'
    };
  },
  computed: {
    sum_billings: function () {

      const bill = this.billings

      let sum = 0

      for (let i = 0; i < bill.length; i++) {
        if (bill[i].invoice_amount) {
          sum += bill[i].invoice_amount
        }
      }

      return sum / 100
    },
    sortedBillings: function () {
      let billings = this.billings;

      // Sortierung durchführen, falls ein Sortierschlüssel vorhanden ist
      if (this.sortKey) {
        billings = billings.slice().sort((a, b) => {
          let valA = a[this.sortKey];
          let valB = b[this.sortKey];

          if (typeof valA === 'string' && typeof valB === 'string') {
            valA = valA.toLowerCase();
            valB = valB.toLowerCase();
          }

          if (this.sortOrder === 'asc') {
            return valA > valB ? 1 : valA < valB ? -1 : 0;
          } else {
            return valA < valB ? 1 : valA > valB ? -1 : 0;
          }
        });
      }

      return billings;
    },
    billings: function () {
      if (
        this.invoicefilter &&
        this.invoicefilter.length > 1 &&
        this.$store.state.billings
      ) {
        return this.$store.state.billings.filter((word) => {

          if (this.invoice_open) {
            return word.invoice_nr.toString().indexOf(this.invoicefilter) != -1 && !word.paid;
          }
          return word.invoice_nr.toString().indexOf(this.invoicefilter) != -1;
        });
      }

      if (this.$store.state.billings && this.invoice_open) {
        return this.$store.state.billings.filter((word) => {
          return !word.paid;
        });

      }

      return this.$store.state.billings;
    },
  },
  mounted() {
    this.loading = true;

    getAllBillings().then((resp) => {
      if (resp.data.error) {
        this.$router.push({ name: "locations" });
      } else {
        this.$store.state.billings = resp.data;



        this.loading = false;
      }
    }).catch(() => {
      localStorage.removeItem("token");
      this.$router.push({ name: "login" });
    });
  },
  methods: {
    sortBy: function (key) {
      this.sortKey = key;
      this.sortOrder = this.sortOrder === 'asc' ? 'desc' : 'asc';
    },
    saveEmailDetails: function () {
      if (this.current_billing.paid_at) {
        this.current_billing.paid = true;
      } else {
        this.current_billing.paid = false;
      }

      if (this.current_billing.emailsend_at) {
        this.current_billing.emailsend = true;
      } else {
        this.current_billing.emailsend = false;
      }


      updateInvoiceInfo({
        current_item: this.current_billing,
      }).then((data) => {
        this.modalSaved1 = true;
        console.log(data);
      });
    },

    openModal: function (item) {
      this.modalSaved1 = false;
      this.current_billing = item;
    },
  },
};
</script>

<style scoped>
.billing-modal-btn {
  cursor: pointer;
  font-weight: 600;
}

.billing-modal-btn:hover {
  color: #00b3fc;
}

.badge-container {
  margin-bottom: 5px;
}

.badge-tag {
  color: #ffffff;
  background-color: #198ae3;
  padding: 4px 5px 4px 5px;
  font-size: 12px;
  display: inline-block;
}
</style>